import { createRoot } from 'react-dom/client';

import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import '@/components/DataGrid/license';
import { IS_DEV_MODE } from '@/constants';
import { ErrorBoundary } from '@/error-handling';
import SnackbarProvider from '@/sections/Snackbar/Provider';
import { defaultTheme } from '@/theme';
import { AnalyticsProvider } from '@/utils/analytics/segment/AnalyticsContext';
import { ApolloProvider } from '@apollo/client';
import { PylonProvider } from '@bolasim/react-use-pylon';
import { DialogsProvider } from '@toolpad/core/useDialogs';
import { RecoilRoot } from 'recoil';
import { RecoilDevTools } from 'recoil-toolkit';

import App from './App';
import apolloClient from './apollo';
import { globalStyles } from './styled';
import { initializeSentry } from './utils/analytics/Sentry';

initializeSentry();

const container = document.getElementById('react-app') as HTMLElement;
const root = createRoot(container);

root.render(
  <AnalyticsProvider>
    <ApolloProvider client={apolloClient}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={defaultTheme}>
          <CssBaseline />
          <GlobalStyles styles={globalStyles} />
          <RecoilRoot>
            {IS_DEV_MODE && <RecoilDevTools />}
            <DialogsProvider>
              <SnackbarProvider>
                <PylonProvider
                  chatSettings={{
                    appId: ENV_CONFIG.PYLON_APP_ID,
                  }}
                  autoBoot
                  shouldInitialize={!!ENV_CONFIG.PYLON_APP_ID}
                >
                  <ErrorBoundary>
                    <App />
                  </ErrorBoundary>
                </PylonProvider>
              </SnackbarProvider>
            </DialogsProvider>
          </RecoilRoot>
        </ThemeProvider>
      </LocalizationProvider>
    </ApolloProvider>
  </AnalyticsProvider>,
);
